import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../header/header";
import { useGame } from "../header/GameContext";
import { ANSWERS_DATA } from "../keywordInput/correctAnswerDatas";
import "./place.css";

function Place({ onFinish, defaultPath, timerMode }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { startTimer, pauseTimer, openHint, isFinalQuiz } = useGame();

  const state = location.state || {};
  const { DateVal, titImgClass } = state;

  /* =========================
     타이머
  ========================= */
  useEffect(() => {
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode]);

  /* =========================
     데이터
  ========================= */
  const contents = DateVal;

  console.log("contents", contents);

  /* =========================
     상태
  ========================= */
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState([]);
  const [showButton, setShowButton] = useState(false);

  const chatBoxRef = useRef(null);

  /* =========================
     공통 스크롤 함수 (🔥 핵심)
  ========================= */
  const scrollToBottom = () => {
    if (!chatBoxRef.current) return;
    chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
  };
  /* =========================
   채팅용 offset 스크롤
  ========================= */
  const scrollWithOffset = () => {
    if (!chatBoxRef.current) return;

    const box = chatBoxRef.current;
    const OFFSET = 80; // 🔥 잘림 방지 여유값

    box.scrollTop = box.scrollHeight - box.clientHeight + OFFSET;
  };

  /* =========================
     채팅 출력 로직
  ========================= */
  useEffect(() => {
    if (idx >= contents.length) {
      setShowButton(true);
      return;
    }

    const item = contents[idx];

    /* 🔥 scroll 타입 */
    if (item.type === "scroll") {
      setIdx((prev) => prev + 1);

      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 0);
      return;
    }

    /* 🔥 일반 채팅 */
    const t = setTimeout(() => {
      setVisible((prev) => [...prev, item]);
      setIdx((prev) => prev + 1);
    }, 1000);

    return () => clearTimeout(t);
  }, [idx]);

  /* =========================
     채팅 추가 시 항상 하단 유지
  ========================= */
  useEffect(() => {
    requestAnimationFrame(scrollWithOffset);
  }, [visible]);

  /* =========================
     버튼 클릭
  ========================= */
  const onBtnClick = () => {
    navigate("/keywordInput");
  };

  return (
    <div className="box content_box1">
      <Header isFinalQuiz={isFinalQuiz(DateVal)} />

      <div className="box_con con_box1 con_pd5 ans0001">
        <div className={`mission_tit ${titImgClass}`} />

        {/* 채팅 영역 (스크롤 주체) */}
        <div
          className="chat_box2 mt24"
          ref={chatBoxRef}
          style={{ overflowY: "auto", maxHeight: "400px" }}
        >
          {visible.map((c, i) => {
            if (c.type === "chatInfo_Talk1") {
              return (
                <div
                  key={i}
                  className={`chatInfo_Talk ${c.marType || ""}`}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              );
            }

            if (c.type === "leftCharacter") {
              return (
                <div key={i} className={`chat_b_left ${c.marType || ""}`}>
                  <div className="chat_b_l_left mr8">
                    <span className={c.chat_icon} />
                  </div>
                  <div className="chat_b_l_right">
                    <p className="chat_tit mb4">{c.chat_tit}</p>
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }

            if (c.type === "left_txt") {
              return (
                <div key={i} className={`chat_b_left ${c.marType || ""}`}>
                  <div className="chat_b_l_left mr8" />
                  <div className="chat_b_l_right">
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }

            if (c.type === "ImgOnly") {
              return (
                <div key={i} className={c.marType || ""}>
                  <img src={c.src} className={c.className} alt="" />
                </div>
              );
            }

            return null;
          })}
        </div>

        {/* 버튼 영역 */}
        {showButton && (
          <div className="chat_btn_area mt20">
            <button className="inputBtn02" onClick={onBtnClick}>
              돌아가기
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Place;
